module.exports = __webpack_public_path__ + "img/introduction_bg.771d99f6.png";